import { render, staticRenderFns } from "./PricingParent.vue?vue&type=template&id=61792e1a&"
import script from "./PricingParent.vue?vue&type=script&lang=js&"
export * from "./PricingParent.vue?vue&type=script&lang=js&"
import style0 from "../../components/pe/pe.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports